import { useEffect, useRef } from 'react';

// Adds `is-visible` to every `.reveal` element inside the returned ref once it scrolls into view.
const useReveal = () => {
    const ref = useRef(null);

    useEffect(() => {
        const root = ref.current;
        if (!root) return undefined;
        // Runs after every render so newly rendered cards (e.g. after filtering) get observed too.
        const targets = root.querySelectorAll('.reveal:not(.is-visible)');

        if (!('IntersectionObserver' in window)) {
            targets.forEach(el => el.classList.add('is-visible'));
            return undefined;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.12 });

        targets.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    });

    return ref;
};

export default useReveal;
